import * as React from "react";
import Svg, { Path, G, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */

function AddCustomerGraphic(props) {
  return (
    <Svg width={220} height={160} viewBox="0 0 220 160" fill="none" {...props}>
      <Path
        d="M144.882 142.73s1.691-5.69-4.739-8.929l4.739 8.929z"
        fill="#E6E6E6"
      />
      <Path
        d="M145.094 142.764s.67-5.615 8.159-5.967l-8.159 5.967z"
        fill="#E6E6E6"
      />
      <Path
        d="M203.482 144.385c-1.19 4.893-63.632 4.482-63.538 0 1.19-4.893 63.632-4.483 63.538 0z"
        fill="#E6E6E6"
      />
      <Path
        d="M27.56 16.009a1.008 1.008 0 100-2.017 1.008 1.008 0 000 2.017zM31.387 16.009a1.008 1.008 0 100-2.017 1.008 1.008 0 000 2.017zM35.214 16.009a1.008 1.008 0 100-2.017 1.008 1.008 0 000 2.017z"
        fill="#fff"
      />
      <Path
        d="M190.157 119.477s-.741-2.511.467-1.692c1.207.82 4.721 2.05 3.455 4.02-1.266 1.971-8.844 12.862-10.07 10.704-.68-1.198 1.691-11.361 1.691-11.361s1.686-.39 1.928 0c.241.39 2.529-1.671 2.529-1.671z"
        fill="#2F2E41"
      />
      <Path
        d="M179.284 55.387l-.226 4.075-2.944 5.888 9.738-.452-.679-6.115.452-2.491-6.341-.905z"
        fill="#FFB8B8"
      />
      <Path
        d="M178.152 62.402s1.586 1.812 5.662-.226l3.171 15.399.453 13.814-13.589-.452.227-14.042 4.076-14.493z"
        fill="#D1D1D1"
      />
      <Path
        d="M170.556 91.72s1.463 7.188 4.199 5.446c2.735-1.741-.59-6.787-.59-6.787l-3.609 1.341zM184.04 130.348l-.226 3.85 3.623 1.132v-5.209l-3.397.227z"
        fill="#FFB8B8"
      />
      <Path
        d="M172.038 90.035v22.647l12.909 11.097 3.17-5.435-9.059-7.473 2.265-5.662 9.512-6.115v-8.832l-18.797-.227z"
        fill="#2F2E41"
      />
      <Path
        d="M181.549 104.076l1.358 11.55.453 15.4h5.889s2.037-13.589-.227-16.986l1.812-14.945-1.812-5.888-7.473 10.869zM186.758 133.972s.227-.906-1.359-.906c-1.585 0-2.264.227-2.264.453-.053.382-.129.76-.227 1.133 0 0-4.075 10.191 0 9.738 4.076-.453 4.756-2.491 4.756-2.491l.453-6.567s-.453-.555-.679-.504c-.227.051-.68-.856-.68-.856z"
        fill="#2F2E41"
      />
      <Path
        d="M182.908 57.648a4.983 4.983 0 10-.001-9.965 4.983 4.983 0 00.001 9.965z"
        fill="#FFB8B8"
      />
      <Path
        d="M183.814 63.765l-1.585-1.812 3.065-3.836 1.238 1.343 7.248 3.17-2.038 19.93s-.226 5.888 1.132 9.965c0 0-2.944 3.623-7.473 2.718l-5.888 1.132s-.681-29.213 4.301-32.61zM178.832 62.634l.26-3.775-1.166 1.51-6.115 4.53.68 25.138 2.037 1.132 3.398-26.949.906-1.586z"
        fill="#FFB800"
      />
      <Path
        d="M173.396 64.672l-1.585.226s-1.133 2.038-1.133 2.265c0 .227-.453 12.003-.453 12.003s-.792 11.89.567 14.154l4.009-4.313-1.405-3.953V64.672z"
        fill="#FFB800"
      />
      <Path
        opacity={0.3}
        d="M182.789 114.613l.312 7.581-.941-.811.629-6.77zM190.318 117.637l-.331.163-.354 10.156.818-1.054-.133-9.265z"
        fill="#000"
      />
      <Path
        d="M196.949 92.75s-1.132 7.248 2.038 6.568c3.17-.68 1.812-6.568 1.812-6.568h-3.85z"
        fill="#FFB8B8"
      />
      <Path
        d="M191.74 62.633h2.038s1.359.68 1.585 2.717c.226 2.039 3.397 11.098 3.397 11.098s3.624 14.947 3.397 16.985h-5.662l.453-4.076-6.114-16.306.906-10.418z"
        fill="#FFB800"
      />
      <Path
        d="M178.67 47.878l-.949-.38s1.986-2.186 4.749-1.996l-.777-.856s1.898-.76 3.626 1.236c.908 1.05 1.958 2.283 2.613 3.672h1.017l-.424.935 1.486.935-1.525-.168c.091.512.105 1.035.041 1.552a2.007 2.007 0 01-.734 1.312s-1.178-2.438-1.178-2.819v.951s-.95-.856-.95-1.426l-.518.666-.259-1.046-3.195 1.046.518-.856-1.986.285.777-1.045s-2.245 1.235-2.332 2.28a5.015 5.015 0 01-.743 2.038s-1.761-4.89.743-6.316z"
        fill="#2F2E41"
      />
      <G filter="url(#prefix__filter0_d)">
        <Path
          d="M143.166 13.336H16.394a6 6 0 00-6 6V43.27a6 6 0 006 6h126.772a6 6 0 006-6V19.336a6 6 0 00-6-6z"
          fill="#fff"
        />
      </G>
      <G filter="url(#prefix__filter1_d)">
        <Path
          d="M143.254 55.18H16.481a6 6 0 00-6 6v23.935a6 6 0 006 6h126.773a6 6 0 006-6V61.18a6 6 0 00-6-6z"
          fill="#fff"
        />
      </G>
      <Path
        d="M130.684 21.285H58.928a1.674 1.674 0 000 3.347h71.756a1.673 1.673 0 100-3.347zM82.359 29.652h-23.43a1.674 1.674 0 000 3.348h23.43a1.674 1.674 0 000-3.348zM108.928 38.02h-50a1.674 1.674 0 000 3.347h50a1.673 1.673 0 000-3.347zM52.216 31.32a12.474 12.474 0 01-2.956 8.089 12.597 12.597 0 01-3.532 2.898 12.435 12.435 0 01-4.873 1.5 12.499 12.499 0 01-4.42-.367 12.025 12.025 0 01-2.6-1.016c-.666-.35-1.299-.76-1.89-1.224a12.541 12.541 0 012.707-21.374 12.543 12.543 0 0117.564 11.495z"
        fill="#E6E6E6"
      />
      <Path
        d="M36.633 32.455s1.141 3.172.254 4.948c-.887 1.776 1.396 3.806 1.396 3.806s5.963-3.045 5.202-4.568c-.762-1.522-2.03-3.552-1.776-4.82l-5.076.634z"
        fill="#FFB8B8"
      />
      <Path
        d="M38.853 33.66a4.06 4.06 0 100-8.121 4.06 4.06 0 000 8.12z"
        fill="#FFB8B8"
      />
      <Path
        d="M36.435 43.438a12.017 12.017 0 01-1.75-.607l.108-3.083 1.142-2.538c.257.201.531.378.82.529.07.038.14.074.216.11 1.07.518 2.82.973 4.516-.296a6.456 6.456 0 001.56-1.756l3.166 1.794.166 1.944.193 2.261a12.432 12.432 0 01-5.716 2.01 12.495 12.495 0 01-4.42-.368z"
        fill="#E40046"
      />
      <Path
        d="M37.215 35.313v.004l-.16 1.657-.084.877-.123 1.303-.412 4.286a12.025 12.025 0 01-2.601-1.016c-.666-.35-1.298-.76-1.89-1.224l-.45-2.084.034-.023 5.686-3.78zM45.728 42.306a12.435 12.435 0 01-4.873 1.5c.093-1.542.228-3.03.38-4.357.08-.68.163-1.316.25-1.896.276-1.863.572-3.128.785-3.3l1.403.927 5.71 2.03-.124 2.197a12.594 12.594 0 01-3.531 2.899z"
        fill="#575A89"
      />
      <Path
        d="M31.945 41.199c-.276-.214-.54-.44-.796-.677l.217-1.407.163-.023.726-.104 1.58 3.435c-.666-.35-1.298-.76-1.89-1.224zM50.177 38.175a12.594 12.594 0 01-4.449 4.13l-.15-.653.8-2.117.976-2.578 2.029.255c.281.307.546.629.794.963z"
        fill="#575A89"
      />
      <Path
        d="M42.725 25.929a4.743 4.743 0 00-2.698-2.063l-.824.66.32-.77a4.362 4.362 0 00-.815-.046l-.742.954.307-.921a4.696 4.696 0 00-3.24 1.927c-.945 1.362-1.105 3.257-.175 4.63.254-.784.564-1.52.82-2.304.2.028.403.029.604.003l.31-.724.087.694a40.765 40.765 0 003.3-.437l-.09-.532.531.442c.28-.065.446-.123.432-.168.678 1.094 1.35 1.792 2.028 2.885.257-1.541.71-2.824-.155-4.23z"
        fill="#2F2E41"
      />
      <Path
        d="M42.5 30.021c.152 0 .275-.246.275-.55 0-.303-.123-.55-.275-.55-.152 0-.275.247-.275.55 0 .304.123.55.275.55z"
        fill="#FFB8B8"
      />
      <Path
        d="M51.606 72.959a12.483 12.483 0 01-2.959 8.093 12.603 12.603 0 01-3.534 2.9 12.445 12.445 0 01-4.876 1.502 12.503 12.503 0 01-4.423-.368 12.042 12.042 0 01-2.602-1.017c-.666-.35-1.3-.76-1.89-1.224a12.55 12.55 0 1120.285-9.885v-.001z"
        fill="#000"
        fillOpacity={0.1}
      />
      <Path d="M39.823 67.102h-1.539v11.715h1.54V67.102z" fill="#fff" />
      <Path d="M44.911 73.73v-1.539H33.196v1.54h11.715z" fill="#fff" />
      <Path
        d="M128.803 63.129H57.046a1.674 1.674 0 100 3.347h71.757a1.673 1.673 0 000-3.347zM80.476 71.496h-23.43a1.674 1.674 0 100 3.347h23.43a1.674 1.674 0 000-3.347zM107.045 79.863h-50a1.674 1.674 0 100 3.348h50a1.674 1.674 0 000-3.348zM213.999 111.147a12.898 12.898 0 01-1.343 5.735 12.9 12.9 0 01-5.608 5.712c-.019.01-.036.019-.055.027a12.895 12.895 0 01-1.976.82 12.82 12.82 0 01-3.918.604 12.813 12.813 0 01-3.328-.435 12.287 12.287 0 01-1.635-.554l-.166-.069a11.956 11.956 0 01-.766-.365l-.108-.056a12.783 12.783 0 01-.799-.456 12.991 12.991 0 01-1.69-1.255c-.092-.079-.183-.162-.272-.243a13.169 13.169 0 01-1.346-1.453 12.894 12.894 0 01-2.277-11.612 12.894 12.894 0 018.145-8.584 12.903 12.903 0 0115.706 6.267 12.902 12.902 0 011.437 5.917h-.001z"
        fill="#E6E6E6"
      />
      <Path
        d="M205.125 116.925a1.933 1.933 0 10.001-3.867 1.933 1.933 0 00-.001 3.867z"
        fill="#2F2E41"
      />
      <Path
        d="M205.664 113.113a1.926 1.926 0 011.661.942 1.933 1.933 0 01.041 1.909 1.932 1.932 0 10-3.211-2.124 1.927 1.927 0 011.51-.727h-.001z"
        fill="#2F2E41"
      />
      <Path
        d="M201.513 114.988a5.68 5.68 0 10-.002-11.36 5.68 5.68 0 00.002 11.36z"
        fill="#2F2E41"
      />
      <Path
        d="M197.055 105.782a5.676 5.676 0 017.871-.596c-.047-.044-.093-.089-.141-.131a5.68 5.68 0 00-9.157 2.373 5.677 5.677 0 001.611 6.116c.048.043.097.083.147.124a5.68 5.68 0 01-.331-7.886z"
        fill="#2F2E41"
      />
      <Path
        d="M201.464 114.941a3.658 3.658 0 100-7.317 3.658 3.658 0 000 7.317z"
        fill="#A0616A"
      />
      <Path
        d="M198.865 112.438s.482 4.428-.288 4.909c-.77.481 4.428 1.155 4.428 1.155s-.77-4.813 1.155-6.064h-5.295z"
        fill="#A0616A"
      />
      <Path
        d="M208.01 120.81v1.399a11.343 11.343 0 01-.962.553v.028h-.055a12.527 12.527 0 01-1.976.819 12.832 12.832 0 01-3.918.605 12.844 12.844 0 01-3.328-.435 12.53 12.53 0 01-1.635-.554l-.167-.07c-.26-.113-.515-.234-.766-.365l-.108-.056a12.98 12.98 0 01-2.488-1.711c-.093-.079-.184-.162-.273-.243a13.344 13.344 0 01-.985-1.019c.041-.291.108-.577.202-.855l.002-.002c.026-.072.057-.143.092-.212.415-.777 1.164-.969 2.097-1.01.524-.023 1.105.002 1.72-.005.324-.001.658-.013.996-.044 2.118-.192 1.733-1.443 1.829-2.117.095-.653.683-.087.722-.05l.002.002a7.48 7.48 0 003.844.675h.001a6.46 6.46 0 01.68-.051c.597-.007.467.164.263.305a2.928 2.928 0 01-.314.176s-.096.578-.192 1.445c-.093.829 1.496 1.218 1.628 1.248l.009.003a3.202 3.202 0 011.763.044 2.092 2.092 0 011.317 1.497z"
        fill="#FFB800"
      />
      <Path
        d="M196.159 122.794c-.005.156-.014.301-.023.435l-.167-.069c-.26-.114-.515-.235-.766-.365l-.108-.057a12.08 12.08 0 01-.798-.456c.008-.136.022-.273.044-.408a7.46 7.46 0 00-.6-4.187c-.046-.094-.073-.145-.073-.145s.673-.578 1.635 0a.626.626 0 01.159.14c.638.755.763 3.477.697 5.112zM206.646 122.79a5.583 5.583 0 01-.009.178c-.524.251-1.065.465-1.619.641l-.033-.819-.123-3.253a.511.511 0 01.06-.271.527.527 0 01.468-.286h1.176c.058 0 .099.119.127.333.075.596.039 1.928-.047 3.477zM198.336 106.711v3.659h.847l1.078-1.155-.145 1.155h3.745l-.232-1.155.463 1.155h.597v-3.659h-6.353z"
        fill="#2F2E41"
      />
      <Path
        d="M197.759 111.039c.159 0 .288-.237.288-.529 0-.293-.129-.53-.288-.53-.16 0-.289.237-.289.53 0 .292.129.529.289.529zM205.171 111.039c.159 0 .289-.237.289-.529 0-.293-.13-.53-.289-.53-.16 0-.289.237-.289.53 0 .292.129.529.289.529z"
        fill="#A0616A"
      />
      <Path
        d="M208.901 121.592a13.453 13.453 0 01-.891.62 11.36 11.36 0 01-.962.554v-2.723s.372.296.962.79c.259.218.561.475.891.759z"
        fill="#FFB800"
      />
      <Defs />
    </Svg>
  );
}

export default AddCustomerGraphic;
